import styled from 'styled-components'
import { Layout } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
	flex-direction: column;
	display: flex;
	max-width: 600px;
	margin: auto;
`
